import { FETCH_SCHEDULE_COLORS, FETCH_SCHEDULE_COLORS_SUCCESS, FETCH_SCHEDULE_COLORS_FAILURE } from '../actions';

const initialState = {
  schedulesColors: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_SCHEDULE_COLORS:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_SCHEDULE_COLORS_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        schedulesColors: action.data
      };
    case FETCH_SCHEDULE_COLORS_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        schedulesColors: []
      };
    default:
      return state;
  }
}